// @ts-nocheck

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { yieldCallback } from '@zillow/yield-callback';

import './style.scss';
import appUtils from 'app/shared/utils/appUtils';
import Button from 'app/shared/core/Button';
import Container from 'app/shared/core/Container';
import IconLeftCaret from 'images/icons/ic-caret-left.svg';
import IconMail from 'images/icons/mail-white.svg';
import PopupModal from 'app/shared/modules/popups/PopupModal';
import ValueConstants from 'app/shared/constants/ValueConstants';

class HdpFullDetailModal extends Component {
  static propTypes = {
    onClickContact: PropTypes.func,
    onHideModal: PropTypes.func,
  };

  static defaultProps = {
    onClickContact: () => {},
    onHideModal: () => {},
  };

  componentDidMount() {
    const { isMobile } = this.props;
    if (isMobile) {
      appUtils.lockVerticalScrolling();
    }
    // Add escape key handler with capture=true to intercept before gallery handlers
    window.addEventListener('keydown', this.handleEscapeKeyCapture, { capture: true });
  }
  componentWillUnmount() {
    const { isMobile } = this.props;
    if (isMobile) {
      appUtils.unlockVerticalScrolling();
    }
    // Remove escape key handler
    window.removeEventListener('keydown', this.handleEscapeKeyCapture, { capture: true });
  }

  handleContactCtaClick = yieldCallback(() => {
    const { onClickContact } = this.props;
    onClickContact();
  });

  handleEscapeKeyCapture = (event) => {
    if (event.key === ValueConstants.ESC_KEY) {
      // Prevent this escape key from reaching gallery modal handlers
      event.stopImmediatePropagation();
      const { onHideModal } = this.props;
      onHideModal();
    }
  };

  render() {
    const { onHideModal, children, isMobile, onClickContact } = this.props;

    return (
      <PopupModal
        aria-labelledby="dialog-title"
        isFullScreen
        onHidePopup={onHideModal}
        paddingTop="0"
        paddingBottom="0"
        useCloseButton={false}
      >
        <div className="HdpFullDetailModal-header">
          <button className="HdpFullDetailModal-header-left" onClick={onHideModal}>
            <img src={IconLeftCaret} className="HdpFullDetailModal-icon-caret" />
            <span className="HdpFullDetailModal-back">Back</span>
          </button>
        </div>
        {isMobile ? children : <Container>{children}</Container>}
        <div className="HdpFullDetailModal-contact-cont">
          <Button onClick={this.handleContactCtaClick} full>
            <img src={IconMail} className="HdpFullDetailModal-contact-icon" />
            Contact now
          </Button>
        </div>
      </PopupModal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isMobile: state.app.device.screenWidth === 'xs' || state.app.device.screenWidth === 'sm',
    listing: state.currentListingDetails.currentListing,
  };
};

export default connect(mapStateToProps)(HdpFullDetailModal);
